mutation generateSecret($customerId: ID!, $contractId: ID!, $productId: ID!, $protocol: EndpointProtocol) {
  generateSecret(customerId: $customerId, contractId: $contractId, productId: $productId, protocol: $protocol) {
    clientId
    secret
    secretLastUpdated
  }
}
